// Shared constants and utilities for Damage Valuation
export const PART_NAMES = {
  'capó': 'Capó',
  'parabrisas_frontal': 'Parabrisas Frontal',
  'parabrisas_trasero': 'Parabrisas Trasero',
  'techo': 'Techo',
  'puerta_delantera_izquierda': 'Puerta Delantera Izquierda',
  'puerta_delantera_derecha': 'Puerta Delantera Derecha',
  'puerta_trasera_izquierda': 'Puerta Trasera Izquierda',
  'puerta_trasera_derecha': 'Puerta Trasera Derecha',
  'guardafango_delantero_izquierdo': 'Guardafango Delantero Izq.',
  'guardafango_delantero_derecho': 'Guardafango Delantero Der.',
  'guardafango_trasero_izquierdo': 'Guardafango Trasero Izq.',
  'guardafango_trasero_derecho': 'Guardafango Trasero Der.',
  'bumper_frontal': 'Bumper/Parachoque Frontal',
  'bumper_trasero': 'Bumper/Parachoque Trasero',
  'espejo_izquierdo': 'Espejo Retrovisor Izq.',
  'espejo_derecho': 'Espejo Retrovisor Der.',
  'faro_delantero_izquierdo': 'Faro Delantero Izq.',
  'faro_delantero_derecho': 'Faro Delantero Der.',
  'faro_trasero_izquierdo': 'Faro Trasero Izq.',
  'faro_trasero_derecho': 'Faro Trasero Der.',
  'llanta_delantera_izquierda': 'Llanta Delantera Izq.',
  'llanta_delantera_derecha': 'Llanta Delantera Der.',
  'llanta_trasera_izquierda': 'Llanta Trasera Izq.',
  'llanta_trasera_derecha': 'Llanta Trasera Der.',
  'chasis': 'Chasis/Bastidor',
  'motor': 'Motor',
  'transmision': 'Transmisión',
  'suspension': 'Suspensión',
  'sistema_electrico': 'Sistema Eléctrico',
  'aire_acondicionado': 'Aire Acondicionado',
  'interior_asientos': 'Interior - Asientos',
  'interior_tablero': 'Interior - Tablero',
  'interior_tapiceria': 'Interior - Tapicería',
  'otro': 'Otro'
};

export const CAUSE_NAMES = {
  'colision_frontal': 'Colisión Frontal',
  'colision_trasera': 'Colisión Trasera',
  'colision_lateral': 'Colisión Lateral',
  'volcadura': 'Volcadura',
  'inundacion': 'Inundación',
  'granizo': 'Daño por Granizo',
  'vandalismo': 'Vandalismo',
  'robo_parcial': 'Robo Parcial',
  'incendio': 'Incendio',
  'caida_objeto': 'Caída de Objeto',
  'animal': 'Colisión con Animal',
  'desgaste_natural': 'Desgaste Natural',
  'falla_mecanica': 'Falla Mecánica',
  'otro': 'Otro'
};

export const SEVERITY_NAMES = {
  'leve': { label: 'Leve', color: 'bg-yellow-100 text-yellow-800' },
  'moderado': { label: 'Moderado', color: 'bg-orange-100 text-orange-800' },
  'severo': { label: 'Severo', color: 'bg-red-100 text-red-800' },
  'reemplazo_total': { label: 'Reemplazo Total', color: 'bg-red-200 text-red-900' }
};

export const INSURANCE_COMPANIES = [
  { code: 'INS', name: 'Instituto Nacional de Seguros (INS)' },
  { code: 'MAPFRE', name: 'Mapfre Seguros' },
  { code: 'ASSA', name: 'ASSA Compañía de Seguros' },
  { code: 'LAFISE', name: 'Lafise Seguros' },
  { code: 'QUALITAS', name: 'Qualitas Seguros' },
  { code: 'OTRO', name: 'Otra aseguradora' }
];

export const formatPrice = (price) => {
  return new Intl.NumberFormat('es-CR', {
    style: 'currency',
    currency: 'CRC',
    maximumFractionDigits: 0
  }).format(price);
};
